import Swiper from 'swiper/bundle';
let afgBlog = {};

afgBlog.addElement = (tag, parent, classAttr = '', text = '') => {
  let el = document.createElement(tag);
  let content = document.createTextNode(text);
  el.appendChild(content);
  el.setAttribute('class',classAttr);

  parent.prepend(el);
  return el;
}

afgBlog.init = (block, parentSection) => {
	let section = document.querySelector(block);
	let currentSlide = section.querySelector('.swiper-slide');
	if(currentSlide == null || currentSlide == undefined) return;
	setCurrentStyles(currentSlide, section, parentSection);
}

let swiperObj = null;
afgBlog.swiper = (block, parentSection) => {

	if(swiperObj !== null) return;

	let section = document.querySelector(block);
	if(section == null || section == undefined) return

	let currentTitleWrapper = section.querySelector('.current-title-wrapper');
	let firstTitle = section.querySelector('article h2 a').textContent;
	let backgroundText = afgBlog.addElement('div', parentSection, 'background-text afg-active', firstTitle);
	
	let slidesPerView = 1.13;
	let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
	if(isSafari) slidesPerView = 1.2;
	
	swiperObj = new Swiper(block + ' .swiper', {
		slidesPerView: slidesPerView,
    	centeredSlides: true,
		spaceBetween: 4,
		autoplay: {
		   delay: 3000,
		   disableOnInteraction: false,
	 	},
		progress:true,
		loop: true,
		speed: 1200,
		grabCursor: true,
		mousewheel: false,
		direction: 'vertical',
		navigation: {
			nextEl: section.querySelector('.swiper-button-next'),
			prevEl: section.querySelector('.swiper-button-prev'),
		},
		on: {
			init: function () {
				var currentSlide = this.slides[this.activeIndex];
				var titleHtml = currentSlide.querySelector('.title-wrapper').innerHTML;
				var titleText = currentSlide.querySelector('.title-wrapper h2 a').textContent;
				currentTitleWrapper.innerHTML = titleHtml;
				backgroundText.textContent = titleText;
				currentTitleWrapper.classList.add('afg-active');
				backgroundText.classList.add('afg-active');
				setCurrentStyles(currentSlide, section, parentSection);

			},
			slideChangeTransitionStart: function () {
				var currentSlide = this.slides[this.activeIndex];
				var titleHtml = currentSlide.querySelector('.title-wrapper').innerHTML;
				var titleText = currentSlide.querySelector('.title-wrapper h2 a').textContent;

				currentTitleWrapper.classList.remove('afg-active');
				backgroundText.classList.remove('afg-active');

				setTimeout(function () {
					currentTitleWrapper.innerHTML = titleHtml;
					backgroundText.textContent = titleText;
					setCurrentStyles(currentSlide, section, parentSection);
				},600);
			},
			slideChangeTransitionEnd: function () {
				currentTitleWrapper.classList.add('afg-active');
				backgroundText.classList.add('afg-active');
				
			}
		}
	});


  let navLinks = section.querySelectorAll('.nav a');
  if(navLinks !== null && navLinks !== undefined) {
		navLinks.forEach(link => {
			
			link.addEventListener('click',function(e){
					e.preventDefault();
					var categoryId = this.closest('li').getAttribute('data-id');
					var firstSlideMatch = section.querySelectorAll('article[data-cat="'+categoryId+'"]')[0];
					var slides = firstSlideMatch.parentElement.children;
					var slideIndex = Array.prototype.indexOf.call(slides, firstSlideMatch);

					swiperObj.slideTo(slideIndex,1200,function(){
						var currentSlide = swiperObj.slides[swiperObj.activeIndex];
						setCurrentStyles(currentSlide, section, parentSection);
					});

			});

		});
	}

}

afgBlog.clickAll = (block) => {
	/** Connect Swiper slide to posts */
	let section = document.querySelector(block);
	let postLinks = section.querySelectorAll('.swiper-slide,.current-title-wrapper');
	if(!postLinks) return;
	  
	postLinks.forEach(link => {
		
		link.addEventListener('click',function(e){
				e.preventDefault();
				var postLink = this.querySelector('a').getAttribute('href');
				location.href = postLink;
				
			});
	});
		  
}

function setCurrentStyles(currentSlide, section, parentSection) {
		
	/** Set main menu styles */
	  var categoryId = currentSlide.getAttribute('data-cat');
	  
	  section.querySelectorAll('.nav li').forEach(item => {
	  	item.classList.remove('afg-active');
	  });
	  section.querySelectorAll('.nav li[data-id="'+categoryId+'"]').forEach(item => {
	  	item.classList.add('afg-active');
	  });

	/** Set vertical slider section styles */
	  var color = currentSlide.getAttribute('data-color');
	  parentSection.setAttribute('style','background-color:'+color+'!important;');

	  var textColor = currentSlide.getAttribute('data-textcolor');
	  if(textColor.length) toggleContrast(textColor, parentSection);

}

function toggleContrast(to, parentSection) {
	const header = document.getElementsByTagName('header')[0];
	let remove = to == 'dark' ? 'light' : 'dark';
	let add = to == 'dark' ? 'dark' : 'light';
	parentSection.classList.remove(remove);
	parentSection.classList.add(add);
	  
	let position = parentSection.getBoundingClientRect();
	if(position.top <= 300 && position.top >= -300) {
	    header.classList.add(add)
	    header.classList.remove(remove);
	}

}

export default afgBlog;